<template>
  <div>
    <Create_raw v-if="this.$store.state.auth.me.app_region === 'US'"></Create_raw>
    <Create_company_house v-else></Create_company_house>
  </div>
</template>
<script>
import Create_raw from './create_raw.vue';
import Create_company_house from './create_ch.vue';
export default {
  name: 'create_company',
  components: {
    Create_raw, Create_company_house
  }
}
</script>